module.exports = __webpack_public_path__ + "img/hobby.ad931f29.svg";